import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ButtonToolbar from 'react-bootstrap/lib/ButtonToolbar';
import BaseSelector from './BaseSelector';
import Button from 'react-bootstrap/lib/Button';
import Popover from 'react-bootstrap/lib/Popover';
import Tooltip from 'react-bootstrap/lib/Tooltip'; 
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
/**
 * MultiSelector widget
 */
class MultiSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.myRef = React.createRef();
    /**
     * @private
     * @type {Array<string>}
     * Stores the search matched items for Shift Key operation.
     */
    this.searchMatched = [];
  }

  componentDidMount() {
    if (this.myRef.current) {
      const currentHeight = this.myRef.current.refs["column-list"].clientHeight;
      this.myRef.current.refs["column-list"].style.minHeight = currentHeight + 2 + "px";
      this.myRef.current.refs["column-list"].style.maxHeight = currentHeight + 2 + "px";
    }
  };

  render() {
    const availableValueStrings = this.props.variable.options && Array.isArray(this.props.variable.options) ? this.props.variable.options.map((value)=>{
      return value.value !== undefined ? value.value : value;
    }) : [];
    const availableValues = [];
    const selectedValues = [];
    const lovItems = [];
    // _options is the one holds options sorted based on the selection.
    // this is updated when the data refresh is done and re-render is invoked from parent iframe.
    let options = [];
    // if there are selected options and sortedOptions (_options) are available, use the sortedOptions
    if (Array.isArray(this.props.variable.value) && this.props.variable.value.length > 0 && this.props.variable._options) {
      options = this.props.variable._options;
    } else {
      options = this.props.variable.options;
    }
    options.forEach((option) => {
      // convert displayName, name, and value to string.
      option.displayName = option.displayName !== undefined && option.displayName !== null ? (option.displayName + "") : "";
      option.name = option.name !== undefined && option.name !== null ? (option.name + "") : "";
      option.value = option.value !== undefined && option.name !== null ? (option.value + "") : "";
      const item = {
        "name": option.displayName || option.name, 
        "value": option.value || option.name, 
        "canRemove": option.canRemove === true
      }
      lovItems.push(item);
      if (Array.isArray(this.props.variable.value) && this.props.variable.value.includes(option.value)) {
        selectedValues.push(item);
      } else {
        availableValues.push(item);
      }
    });
    // make sure to add the newly created options to the selected options
    if (this.props.variable.value && Array.isArray(this.props.variable.value)) {
      this.props.variable.value.forEach((val)=>{
        // convert val to string.
        val = val !== undefined && val !== null ? (val + "") : ""; 
        if (!availableValueStrings.includes(val)) {
          const newOption = {value:val, name: val, displayName: val, canRemove: true};
          if (!selectedValues.map(val => {return val.value}).includes(val)) {
            selectedValues.push(newOption);
          }
          if (!options.map(val => {return val.value}).includes(val)) {
            options.push(newOption);
          }
          lovItems.push(newOption);
        }
      });
    }    
    const values = this.props.variable.isUpdated ? lovItems : selectedValues.concat(availableValues);
    this.props.variable.sortedOptions = selectedValues.concat(availableValues);

    const _onItemSelect = (value, event, values/*, searchMatched*/) => {
      const currentSelections = this.props.variable.value || [];
      const currentValueIndex = currentSelections.indexOf(value.item.value);
      if (event.shiftKey) {
        this._handleShiftClick(
          values,
          {}, 
          value.item, 
          this.lastSelectedColumn, 
          this.lastShiftSelectedColumn
        );
        this.lastShiftSelectedColumn = value.item.value;
      } else if (currentValueIndex === -1) {
        currentSelections.push(value.item.value);
      } else {
        currentSelections.splice(currentValueIndex, 1);
      }
      this.lastSelectedColumn = value.item;
      //this.props.variable.value = currentSelections;
      this.props.onSelectionChange(this.props.variable, currentSelections);
    };

   
    const widget = (
      <div className="multi-select-list-wrapper">
        <BaseSelector 
          ref={this.myRef} 
          label={this.props.variable.displayName || this.props.variable.name}
          autoSelect={false}
          selectedItems={this.props.variable.value} 
          items={values}
          onDeleteCreatedOption={(items/*the latest available options that reflects manually added options*/)=>{
              this.props.variable.options = items;
            }
          }
          getMessage={this.props.getMessage}
          allowCreate={true}
          disabledItems={this.props.disabledItems || []}
          lovWidgetType={this.props.variable.lovWidgetType}
          enableDragAndDrop={false}
          onItemSelect={_onItemSelect}/>
        <ButtonToolbar className={"multi-select-list-toolbar"}>
          <Button style={{"width": "70px",  "marginBottom": "5px"}} onClick={()=>{
            const searchMatched = this.myRef.current ? this.myRef.current.getSearchMatched() : [];
            if (!this.props.variable.value) {
              this.props.variable.value = [];
              this.lastShiftSelectedColumn = '';
            }
            searchMatched.forEach((match)=>{
              if (!this.props.variable.value.includes(match.value)) {
                this.props.variable.value.push(match.value);
              }
            });
            // make sure to call parent's onSelectionChange so that selection remains after clicking the Run button.
            this.props.onSelectionChange(this.props.variable, this.props.variable.value);
          }} bsSize='xs'>{this.props.getMessage("dataframe.Select All")}</Button>
          <Button style={{"width": "70px", "marginBottom": "5px"}} onClick={()=>{
            // clear the selection
            const searchMatched = this.myRef.current ? this.myRef.current.getSearchMatched() : [];            searchMatched.forEach(match => {
              const index = this.props.variable.value.indexOf(match.value);
              if (index > -1) {
                this.props.variable.value.splice(index, 1);
              }
            });
            this.lastShiftSelectedColumn = '';
            // make sure to call parent's onSelectionChange so that selection remains after clicking the Run button.
            this.props.onSelectionChange(this.props.variable, this.props.variable.value);
          }} bsSize='xs'>{this.props.getMessage("dataframe.Select None")}</Button>
          <Button className={this.props.variable.lovWidgetType === "list" ? "hidden" : ""} 
            style={{"width": "70px", "float": "right", "marginRight": "10px", "marginBottom": "5px"}} 
            onClick={()=>{
              // close the dialog
              document.body.click();
          }} bsSize='xs'>{this.props.getMessage("dialog.Close")}</Button>
        </ButtonToolbar>  
      </div>  
    );
    if (this.props.variable.lovWidgetType !== "list") {
      const tooltip = (
        <Popover className="multi-select-popover">
          {widget}
        </Popover>
      );
      let labels = selectedValues.map(option => {return option.name}).join(", ");
      if (this.props.variable.multivalued && this.props.variable.useAllValuesAsDefaultValues && (!this.props.variable.value || this.props.variable.value.length === 0)) {
        labels = this.props.variable.optionsAltEmptyLabelName || this.props.getMessage("search.All");
      }
      const labelWrapper = selectedValues.length > 0 ? (
        <OverlayTrigger trigger={"hover"} overlay={<Tooltip>{labels}</Tooltip>} rootClose={true} placement={"top"}>
          <div className="label-wrapper"><div className="values-wrapper">{labels}</div><div className="caret"></div></div>
        </OverlayTrigger>
      ) : (
        <div className="label-wrapper"><div className="values-wrapper">{labels}</div><div className="caret"></div></div>
      )
      return (
        <OverlayTrigger trigger={"click"} overlay={tooltip} rootClose={true} placement={this.props.index > 5 ?  "top" : "bottom"}>
          <Button className="open-lov-window-button">
            {labelWrapper}
          </Button>
        </OverlayTrigger>
      );
    } else {
      return widget;
    }
  }
}
export default MultiSelector;